<template>
  <div class="vhp-table">
    <div class="vhp-table-top" v-if="!hideTop">
      <h3 class="title">{{ title }}</h3>

      <div class="vhp-table-top-slot">
        <slot name="top"> </slot>
        <div class="vhp-input" v-if="!$slots.top && !hideSearch">
          <input
            class="append-icon"
            type="text"
            name="search"
            id="search"
            v-model="searchKeyword"
            placeholder="검색어를 입력하세요."
          />
          <img
            class="icon"
            src="@/assets/image/magnify.svg"
            width="16"
            height="16"
            alt="magnify"
          />
        </div>
      </div>
    </div>
    <div class="vhp-table-content">
      <table :class="[dense ? 'dense' : '']">
        <thead v-if="headers">
          <tr v-if="!$slots.head">
            <th v-if="showIndex" :class="[dense ? 'dense' : '']">번호</th>
            <th
              v-for="header in headers"
              :key="'vhp-table-header-' + header.value"
              :style="
                header.width
                  ? 'min-width:' +
                    header.width +
                    'px; max-width:' +
                    header.width +
                    'px;'
                  : ''
              "
              :class="[dense ? 'dense' : '']"
            >
              {{ header.text }}
            </th>
          </tr>

          <slot name="head"> </slot>
        </thead>

        <tbody v-if="items && items.length > 0 && (!grid || grid === 2)">
          <tr
            v-for="(item, idx) in filteredItems.slice(
              currPage * itemsPerPage,
              currPage * itemsPerPage + itemsPerPage
            )"
            :key="'vhp-table-item-' + idx"
            :class="[grid ? 'grid-' + grid : '']"
          >
            <td v-if="showIndex" :class="[dense ? 'dense' : '']">
              {{ filteredItems.length - idx - currPage * itemsPerPage }}
            </td>

            <td
              v-for="(header, hidx) in headers"
              :key="idx + '-' + hidx"
              :style="[header.align ? 'text-align:' + header.align : '']"
              :class="[dense ? 'dense' : '']"
            >
              <slot :name="'item-' + header.value" v-bind:item="item"> </slot>
              <span v-if="!$slots['item-' + header.value]">
                {{ item[header.value] }}
              </span>
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="items && items.length > 0 && grid > 2">
          <template
            v-for="(itemGroup, groupIdx) in filteredItems
              .slice(
                currPage * itemsPerPage,
                currPage * itemsPerPage + itemsPerPage
              )
              .reduce((acc, _, index, array) => {
                if (index % 2 === 0) {
                  acc.push(array.slice(index, index + 2));
                }
                return acc;
              }, [])"
            :key="'vhp-table-group-' + groupIdx"
          >
            <tr :class="[grid ? 'grid-' + grid : '']">
              <template
                v-for="(item, idx) in itemGroup"
                :key="'vhp-table-item-' + idx"
              >
                <td
                  v-for="(header, hidx) in headers"
                  :key="idx + '-' + hidx"
                  :style="[header.align ? 'text-align:' + header.align : '']"
                  :class="[dense ? 'dense' : '']"
                >
                  <slot :name="'item-' + header.value" v-bind:item="item">
                  </slot>
                  <span v-if="!$slots['item-' + header.value]">
                    {{ item[header.value] }}
                  </span>
                </td>
              </template>
            </tr>
          </template>
        </tbody>

        <tbody v-else class="empty-tbody">
          <tr>
            <td :colspan="headers.length + (showIndex ? 1 : 0)">
              {{ $t("콘텐츠없음") }}
            </td>
          </tr>
        </tbody>

        <tfoot></tfoot>
      </table>
    </div>

    <div class="vhp-table-bottom" v-if="!hideBottom">
      <div class="pagination" v-if="!infinitePage">
        <div class="page-button prev double" @click="toFirst()">
          <span />
          <span />
          <span />
          <span />
        </div>
        <div class="page-button prev" @click="prev()">
          <span />
          <span />
        </div>

        <div class="page-number-wrap">
          <span
            v-for="page in range(pageTab * 10 + 1, pageTab * 10 + 10)"
            :key="'vhp-page-' + page"
            class="page-number"
            :class="{ active: currPage === page - 1 }"
            @click="currPage = page - 1"
          >
            {{ page }}
          </span>
        </div>

        <div class="page-button next" @click="next()">
          <span />
          <span />
        </div>

        <div class="page-button next double" @click="toLast()">
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>

      <div class="more" v-else>
        <button
          class="vhp-button"
          @click="itemsPerPage += 50"
          v-if="filteredItems.length > itemsPerPage"
        >
          {{ $t("더 보기") }}
        </button>

        <button
          class="vhp-button"
          @click="scrollUp()"
          v-else-if="itemsPerPage > 100"
        >
          {{ $t("처음으로") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "전체목록",
    },
    perPage: {
      type: Number,
      default: 10,
    },
    infinitePage: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    hideTop: {
      type: Boolean,
      defualt: false,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    hideBottom: {
      type: Boolean,
      defualt: false,
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showIndex: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    grid: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    filteredItems() {
      let items = this.items;
      if (this.searchKeyword) {
        items = items.filter((e) => {
          let exist = false;
          for (let k in e) {
            if (e[k] && e[k].toString().indexOf(this.searchKeyword) !== -1) {
              exist = true;
            }
          }
          return exist;
        });
      }
      return items;
    },

    pageTab() {
      return Math.floor(this.currPage / 10);
    },
    maxPageTab() {
      return Math.floor(this.filteredItems.length / this.itemsPerPage) + 1;
    },
  },
  data() {
    return {
      searchKeyword: "",
      hrefPath: "/investment/notice/",
      hrefKey: "id",

      itemsPerPage: 10,
      currPage: 0,
    };
  },
  mounted() {
    if (this.infinitePage) {
      this.itemsPerPage = 100;
    }
  },
  watch: {},
  methods: {
    prev() {
      this.currPage = this.currPage > 0 ? this.currPage - 1 : this.currPage;
    },

    next() {
      this.currPage =
        this.currPage < this.maxPageTab - 1 ? this.currPage + 1 : this.currPage;
    },

    toFirst() {
      this.currPage = 0;
    },

    toLast() {
      this.currPage = this.maxPageTab - 1;
    },

    range(start, end) {
      if (end > this.maxPageTab) {
        end = this.maxPageTab;
      }
      return new Array(end - start + 1)
        .fill(undefined)
        .map((_, i) => i + start);
    },

    scrollUp() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" src="./vhpTable.scss"></style>
